/* global webpack */

import 'gleam-shared/tinyFA/index.scss'

import Lock from 'gleam-shared/promises/lock'
import onceIntersects from 'gleam-shared/browser/onceIntersects'

import { cachedRequest } from 'gleam-shared/network/http'
import { readDom, writeDom } from 'gleam-shared/browser/fastDom'

import FAILED_ICON from 'gleam-images/modern_icons/status-failed.svg?inline'

const TOKEN = webpack.fontAwesomeKit
const VERSION = webpack.fontAwesomeVersion

const MARGIN = '0px'
const NAME_RE = /^fa-/
const FW_CLASS = 'fa-fw'
const KIT_STYLE = 'kit'

const HIDDEN_ATTR = 'aria-hidden'
const MARKER_ATTR = 'data-tiny-fa'
const INLINE_CLASS = 'svg-inline--fa'

const STYLES = [
  { name: 'brands',
    classes: ['fab', 'fa-brands'] },
  { name: 'regular',
    classes: ['far', 'fa-regular'] },
  { name: 'light',
    classes: ['fal', 'fa-light'] },
  { name: 'thin',
    classes: ['fat', 'fa-thin'] },
  { name: 'duotone',
    classes: ['fad', 'fa-duotone'] },
  { name: KIT_STYLE,
    classes: ['fak', 'fa-kit'] },
  { name: KIT_STYLE,
    classes: ['fakd', 'fa-kit-duotone'] },
  { name: 'solid',
    classes: ['fas', 'fa-solid'] }
]

const CLASSES = STYLES.flatMap(({ classes }) => classes)
const [unlock, onceUnlocks] = Lock()

if (TOKEN && VERSION) {
  onInject(CLASSES, injectionCallback)
}

export function unlockTinyFA() {
  console.info('Unlocking the tiny FA. It was locked to avoid hydration mismatches.')
  return unlock()
}

function injectionCallback(source) {
  onceIntersects(source, MARGIN, intersectionCallback)
}

function intersectionCallback(source) {
  const url = faUrl(Array.from(source.classList))

  if (source.hasAttribute(MARKER_ATTR)) {
    return
  }

  if (!url) {
    console.warn(`Couldn't construct a FA URL for ${source.className}!`, source)
    return
  }

  return cachedRequest(url, { mode: 'cors' }).then((icon) => {
    onceUnlocks(() => {
      writeDom(() => {
        source.replaceWith(faIcon(icon, source))
      })
    })
  }, (error) => {
    console.warn(`Couldn't fetch a FA Icon for ${source.className} using ${url}!`, source, error)

    onceUnlocks(() => {
      writeDom(() => {
        source.replaceWith(faIcon(FAILED_ICON, source, error))
      })
    })
  })
}

function faIcon(icon, source, error) {
  const span = document.createElement('span')
  span.innerHTML = icon

  const svg = span.firstElementChild

  for (const attr of source.attributes) {
    svg.setAttribute(attr.name, attr.value)
  }

  svg.setAttribute('class', `${svg.getAttribute('class')} ${INLINE_CLASS}`)
  svg.setAttribute(HIDDEN_ATTR, 'true')
  svg.setAttribute(MARKER_ATTR, error ? error.message : 'true')
  svg.querySelector('path')?.setAttribute('fill', 'currentColor')

  return svg
}

function faUrl(classList) {
  const name = faName(classList)
  const style = faStyle(classList)

  if (!style || !name) {
    return null
  } else if (style === KIT_STYLE) {
    return `https://kit-uploads.fontawesome.com/${TOKEN}/icons/${name}-1.svg?token=${TOKEN}`
  } else {
    return `https://ka-p.fontawesome.com/releases/v${VERSION}/svgs/${style}/${name}.svg?token=${TOKEN}`
  }
}

function faName(classList) {
  const sourceClasses = classList.filter((sourceClass) => {
    if (sourceClass === FW_CLASS) {
      return false
    }

    return !CLASSES.includes(sourceClass)
  })

  const nameClass = sourceClasses.find((sourceClass) => {
    return NAME_RE.test(sourceClass)
  })

  return nameClass?.replace(NAME_RE, '')
}

function faStyle(classList) {
  const variation = STYLES.find(({ classes }) => {
    return classes.some((className) => {
      return classList.includes(className)
    })
  })

  return variation?.name
}

function onInject(classes, callback) {
  if (!globalThis.MutationObserver) {
    return
  }

  const known = new Set()
  const observer = new globalThis.MutationObserver(delayCheck)
  observer.observe(document.body, { childList: true, subtree: true })

  function delayCheck() {
    readDom(check)
  }

  function check() {
    for (const className of classes) {
      for (const source of document.getElementsByClassName(className)) {
        if (!known.has(source)) {
          known.add(source)
          callback(source)
        }
      }
    }
  }
}
